/**
 * LocationMarker (Iteration 12 — N7)
 * 
 * Custom marker with status-driven styling via theme tokens only.
 * NO hex literals — all colors from theme.palette.
 * 
 * Props:
 *   status: 'has-counts' | 'no-counts' | 'stale'
 *   label: string (optional label text)
 *   isSelected: boolean
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PlaceIcon from '@mui/icons-material/Place';

export default function LocationMarker({
  status = 'no-counts',
  label,
  isSelected = false,
}) {
  const theme = useTheme();

  // Status → theme color mapping (no hex literals)
  const colorMap = {
    'has-counts': theme.palette.success.main,
    'no-counts': theme.palette.neutral?.main || theme.palette.grey[500],
    stale: theme.palette.warning.main,
  };

  const color = colorMap[status] || colorMap['no-counts'];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        transform: isSelected ? 'scale(1.2)' : 'scale(1)',
        transition: 'transform 0.15s ease',
        filter: isSelected ? `drop-shadow(0 0 6px ${color})` : 'none',
      }}
    >
      <PlaceIcon
        sx={{
          fontSize: 32,
          color: color,
        }}
      />
      {label && (
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            px: 0.5,
            borderRadius: 0.5,
            fontSize: '0.65rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            mt: -0.5,
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
}
